module.exports = __webpack_public_path__ + "c3cdc2861ea15d8d93fa1628d0a876e5.woff";